module.exports = __webpack_public_path__ + "img/customer.6e70efe8.jpg";